import { API_BASE } from "../config/api";

const requests = new Map();
const TTL_MS = 60_000;
const MAX_ENTRIES = 64;

function trimCompletedRequests() {
  while (requests.size > MAX_ENTRIES) {
    const oldestCompleted = [...requests].find(([, value]) => !value.pending);
    if (!oldestCompleted) return;
    requests.delete(oldestCompleted[0]);
  }
}

export function loadSteamHistory(path) {
  const cached = requests.get(path);
  if (cached && (cached.pending || cached.expires > Date.now())) return cached.promise;

  const entry = { pending: true, expires: 0 };
  entry.promise = fetch(`${API_BASE}${path}`, { cache: "no-store" })
    .then(async response => {
      if (!response.ok) throw new Error(`Steam history ${path}: HTTP ${response.status}`);
      const rows = await response.json();
      if (!Array.isArray(rows)) throw new Error(`Steam history ${path}: expected an array`);
      entry.pending = false;
      entry.expires = Date.now() + TTL_MS;
      trimCompletedRequests();
      return rows;
    })
    .catch(error => {
      if (requests.get(path) === entry) requests.delete(path);
      throw error;
    });
  requests.delete(path);
  requests.set(path, entry);
  trimCompletedRequests();
  return entry.promise;
}
